import { useMutation } from '@tanstack/react-query';
import api from 'services/api/api';
import { IAutocomplete } from 'utils/forms/autocomplete';

export const getResourceGroupsByFiltersAndLimit = async (
	busca?: string,
	limit?: Number,
	orderBy?: string,
	sort?: string
) => {
	const response = await api.get('/grupoRecurso/filtroRecurso', {
		params: {
			busca,
			limit,
			orderBy,
			sort,
		},
	});

	return response.data;
};

export const useResourceGroupListAsMutate = ({
	busca,
	limit,
	orderBy,
	sort,
}: IAutocomplete) => {
	const _order = orderBy || 'nome_grupo_recurso';
	const _sort = sort || 'ASC';
	return useMutation(() =>
		getResourceGroupsByFiltersAndLimit(busca, limit, _order, _sort)
	);
};
